export const AnalyticsEvents = {
  APPLICATION_PRICE_MENU_CLICK: 'application-price-menu-click',
  DCS_DEPOSIT_SUCCESS: 'DCS_DEPOSIT_SUCCESS',
  DEPOSIT_OVERDUE_SUCCESS: 'DEPOSIT_OVERDUE_SUCCESS',
  DEPOSIT_REQUEST: 'DEPOSIT_REQUEST',
  DEPOSIT_SLIDER_MAXED_OUT: 'deposit-slider-maxed-out',
  DEPOSIT_SUCCESS: 'DEPOSIT_SUCCESS',
  INITIATE_CHECKOUT: 'initiate-checkout',
  MONTHLY_PAYMENT_CHANGED: 'MONTHLY_PAYMENT_CHANGED',
  /**
   * This event name is used for Google Ads / Facebook Pixel conversion tracking in Segment, do not
   * change without updating in Segment
   * Tickets:
   * - https://fairloo.atlassian.net/browse/FCSE-4758
   * - https://fairloo.atlassian.net/browse/FCUK-1974
   * Note: Still used for UK flows. Sweden flows now use trackPurchase instead.
   */
  PURCHASE_GRANTED: 'purchase-granted',
  SUBMIT_CREDIT_APPLICATION_STEP: 'submit-credit-application-step',
  WITHDRAWAL: 'WITHDRAWAL',
  /** Temporary*/
  AXIOS_GLOBAL_ERROR_TOAST: 'axios-global-error-toast',
  /** Temporary: decide whether global 401/403 auth-token clearing can be removed */
  AXIOS_GLOBAL_AUTH_TOKEN_REMOVAL: 'axios-global-auth-token-removal',
  modalOpen: (name: string) => `modal-open-${name}`,
  CHAT_WIDGET_OPEN: 'chat-widget-open',
  CHAT_WIDGET_CLOSE: 'chat-widget-close',
  // TODO(EC-1004): Remove once newProductHomepage is fully rolled out
  PRODUCT_HOME: {
    ACTION_CLICKED: 'product-home-action-clicked',
    NOTIFICATION_CLICKED: 'product-home-notification-clicked',
    PROMOTION_CLICKED: 'product-home-promotion-clicked',
    LOAD_FAILED: 'product-home-load-failed',
  },
  SE: {
    PLUS1_BANNER_LOADED: 'plus1-banner-loaded',
    PLUS1_BANNER_CLICK: 'plus1-banner-click',
    MONEEZY_BANNER_LOADED: 'moneezy-banner-loaded',
    MONEEZY_BANNER_CLICK: 'moneezy-banner-click',
    OPEN_BANKING_CHOICE_OPT_IN: 'se-open-banking-choice-opt-in',
    OPEN_BANKING_CHOICE_OPT_OUT: 'se-open-banking-choice-opt-out',
    OPEN_BANKING_LOADER_SHOWN: 'se-open-banking-loader-shown',
    OPEN_BANKING_COMPLETION: 'se-open-banking-completion',
    OPEN_BANKING_RECOVERY_DECLINE: 'se-open-banking-recovery-decline',
    EMAIL_VERIFICATION_OTP_RESEND: 'se-email-verification-otp-resend',
    MOBILE_VERIFICATION_OTP_RESEND: 'se-mobile-verification-otp-resend',
    MANUAL_APPROVAL: 'se-manual-approval',
    INCOME_VERIFICATION_RECOVERY_DECLINE: 'se-income-verification-recovery-decline',
  },
  UK: {
    CREDIT_APPROVED: 'uk-credit-approved',
    /**
     * This event name is used for Facebook Pixel conversion tracking in Segment, do not change
     * without updating in Segment
     * Ticket: https://fairloo.atlassian.net/browse/FCUK-1976
     */
    SUBMIT_CREDIT_APPLICATION: 'uk-submit-credit-application',
    CHAT_WIDGET_MESSAGE_SENT: 'chat-widget-message-sent',
  },
} as const;
